import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRoute = '/therapist-groups';

@Injectable({
  providedIn: 'root'
})
export class TherapistGroupService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }
}
